import { LoggedInUserModel } from '@app/shared';
import { AuthActions, AuthActionTypes } from './auth.actions';
export interface AuthState {
  loggedIn: boolean,
  user: LoggedInUserModel,
  encodedToken: string,
  encryptedUserId: string,
  defaultRedirectRouteUrl: string,
  refreshToken: string
}

export const initialAuthState: AuthState = {
  loggedIn: false,
  user: undefined,
  encodedToken: null,
  encryptedUserId: null,
  defaultRedirectRouteUrl: null,
  refreshToken: null
};

export function authReducer(state = initialAuthState,
  action: AuthActions): AuthState {
  switch (action.type) {
    case AuthActionTypes.LoginAction:
      return {
        loggedIn: true,
        user: action.payload.user,
        encodedToken: action.payload.encodedToken,
        encryptedUserId: action.payload.encryptedUserId,
        defaultRedirectRouteUrl: action.payload.defaultRedirectRouteUrl,
        refreshToken: action.payload.refreshToken
      };
    case AuthActionTypes.LoginUpdateAction:
      return { ...state, ...action.payload };
    case AuthActionTypes.LogoutAction:
      return {
        loggedIn: false,
        user: undefined,
        encodedToken: null,
        encryptedUserId: null,
        defaultRedirectRouteUrl: null,
        refreshToken: null
      };
    default:
      return state;
  }
}
